import { styled } from '../../../theme/stitches.config';

export const SMPStatsWrapper = styled.withConfig({ componentId: 'H2hWidget', displayName: 'SMPStatsWrapper' })('div', {
  px: `calc(10px + $2)`,
  bc: '$sportEntityContainerPrimaryBgColor',
});
